var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38334",
    "data-name": "Group 38334",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.842,
    height: 32.318,
    viewBox: "0 0 34.842 32.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.132,0l8.711,16.159L26.132,32.318H8.711L0,16.159,8.711,0Z",
    transform: "translate(0 0)",
    fill: "#5586d4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_exam_3054500",
    transform: "translate(11.196 8.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37998",
    "data-name": "Group 37998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65384",
    "data-name": "Path 65384",
    d: "M139.615,23.123h.5v1.291A1.692,1.692,0,0,0,141.8,26.1h4.6a1.692,1.692,0,0,0,1.687-1.687V23.123h.5a1.439,1.439,0,0,1,1.435,1.435v12.5A1.439,1.439,0,0,1,148.6,38.5h-8.98a1.439,1.439,0,0,1-1.435-1.435v-12.5A1.439,1.439,0,0,1,139.615,23.123Zm2.19-1.313h4.6a.921.921,0,0,1,.919.918v1.686a.921.921,0,0,1-.919.919h-4.6a.921.921,0,0,1-.919-.919V22.728A.921.921,0,0,1,141.8,21.81Zm-1.682,6.064.626.615,1.379-1.512.605.551-1.952,2.139-1.232-1.211Zm2.9.62h5.637v.8h-5.637Zm-2.9,3.143.626.615,1.379-1.512.605.551-1.952,2.139L139.55,32.22Zm2.9.62h5.637v.8h-5.637Zm-2.9,3.143.626.615,1.379-1.512.605.551-1.952,2.139-1.232-1.211Zm2.9.62h5.637v.8h-5.637Z",
    transform: "translate(-138.18 -21.81)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessmentIcon.638febd57bff8dfd94895c0af2a44b4f.svg";
export { ForwardRef as ReactComponent };